export default __webpack_public_path__ + "static/media/cfojournalLogo.b14344bd.png";